<template>
  <div class="case-explain">
    <header>
      <div class="title-box">
        <span class="title">案例详解</span>
        <!-- 第一层添加按钮 -->
        <i class="iconfont icon-nav-quickly-add" @click="dialogSort = true"></i>
      </div>
      <el-button size="small" v-if="JSON.stringify(currentItem) != '{}' && funAuth.includes(52)" @click="addOpen()" type="primary">新 建</el-button>
    </header>
    <div class="content-bottom">
      <div class="pull-left menu-bar">
        <div class="aside-body">
          <draggable v-model="meunList" @update="sortMenu()" :options="groundsList">
            <div class="list-item" v-for="(item ,index) in meunList" @click="clickCurrent(item)" :class="item.checked?'active':''" :key="index">
              <i class="iconfont icon-yidong pull-left"></i>
              <span class="pull-left">{{item.menu_name}}</span>
              <i class="iconfont icon-Rectangle1 pull-right" @click="del(item.id)"></i>
              <i class="iconfont icon-Rectangle2 pull-right" @click="editOpen(item.id,item.menu_name)"></i>
            </div>
          </draggable>
        </div>
      </div>
      <div class="pull-right detail-bar">
        <div class="content-box">
          <el-table :data='tableData' tooltip-effect='dark' style='width: 100%;height: calc(100% - 60px);' class="el-table-01">
            <el-table-column
              prop="title"
              label="名称"
              width="300">
            </el-table-column>
            <el-table-column
              label="排序"
              width="134">
              <template slot-scope="scope">
                <i class="iconfont icon-jianjuxiao" @click="sort(scope.row.id,1,scope.row.sort)"></i>
                <i class="iconfont icon-jianjuda" @click="sort(scope.row.id,2,scope.row.sort)"></i>
              </template>
            </el-table-column>
            <el-table-column
              label="创建时间"
              width="236">
              <template slot-scope="scope">
                {{scope.row.create_time | formatDate('yyyy-MM-dd HH:mm')}}
              </template>
            </el-table-column>
            <el-table-column
              label="操作">
              <template slot-scope="scope">
                <span class="operator-btn" @click="openEdit(scope.row)" v-if="funAuth.includes(53)">编辑</span>
                <span class="operator-btn" @click="delDetail(scope.row.id)" v-if="funAuth.includes(54)">删除</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change='handleSizeChange'
            @current-change='handleCurrentChange'
            :current-page='pageNum'
            :page-sizes='[10, 20, 50, 100]'
            :page-size='pageSize'
            layout='total, sizes, prev, pager, next, jumper'
            :total='tableTotal'>
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 新增弹窗 -->
    <div class="mask n1" v-if="caseExplainDialog"></div>
    <transition name="slide">
      <help-document-create v-if="caseExplainDialog" :menuId="currentItem.id"></help-document-create>
    </transition>
    <el-dialog
      title="名称"
      :visible.sync="dialogSort"
      width="380px"
      @close="handleClose">
      <el-input v-model.trim="input" maxlength="16" placeholder="请输入"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSort = false">取 消</el-button>
        <el-button type="primary" @click="menuCreate()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import helpDocumentCreate from './help-document-create.vue'
import { mapState, mapMutations } from 'vuex'
import mixin from '@/common/js/mixins.js'

export default {
  name: 'caseExplain', // 案例详解组件
  components: {
    draggable,
    helpDocumentCreate
  },
  mixins: [mixin],
  data () {
    return {
      moduleId: 16, // 模块ID
      dialogAdd: false, // 新增弹窗
      dialogSort: false, // 菜单新增弹窗
      input: '', // 菜单名称
      currentId: '', // 菜单id
      // 菜单列表
      meunList: [],
      pageNum: 1,
      pageSize: 10,
      tableTotal: 0,
      currentItem: {}, // 当前选中菜单
      tableData: []
    }
  },
  created () {
    this.getMenuList().then(() => {
      this.clickCurrent(this.meunList[0])
    })
  },
  mounted () {
    this.queryFchBtnAuth(({moduleId: this.moduleId}))
  },
  methods: {
    // 删除详情列表
    delDetail (id) {
      this.$confirm('确定要删除该数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.deleteDoc({'id': id}).then(res => {
          this.$message({
            showClose: true,
            type: 'success',
            message: '操作成功!'
          })
          // 刷新详情列表
          this.getMenuDetailList(this.currentItem.id)
        })
      })
    },
    // 打开编辑
    openEdit (obj) {
      this.setCaseExplainDialog(true)
      this.setTheme(this.currentItem.menu_name)
      this.openEditDialog(obj)
    },
    // 排序
    sort (id, direction, sort) {
      let obj = {
        'id': id,
        'menu_id': this.currentItem.id,
        'sort': sort,
        'direction': direction // int 交换方向，1和前面的交换，2和后面的交换
      }
      this.$http.updateDocSort(obj).then(res => {
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
        this.getMenuDetailList(this.currentItem.id)
      })
    },
    // 新建
    addOpen () {
      this.openEditDialog(null)
      this.setTheme(this.currentItem.menu_name)
      this.setCaseExplainDialog(true)
    },
    ...mapMutations({
      setCaseExplainDialog: 'CASE_EXPLAIN_DIALOG', // 开关公共新增弹窗
      openEditDialog: 'OPENEDIT', // 打开公共编辑弹窗
      setTheme: 'THEME' // 设置公共新增弹窗主题
    }),
    // 获取菜单详情列表
    getMenuDetailList (id) {
      let obj = {
        'menu_id': id,
        'pageSize': this.pageSize,
        'pageNum': this.pageNum
      }
      this.$http.queryDocList(obj).then(res => {
        this.tableData = res.dataList
        this.pageNum = res.pageInfo.pageNum
        this.pageSize = res.pageInfo.pageSize
        this.tableTotal = res.pageInfo.totalRows
      })
    },
    // 菜单排序
    sortMenu () {
      let obj = {
        'menu_type': 3,
        'dataList': this.meunList
      }
      this.$http.swapMenuSort(obj).then(res => {
        this.$message({
          showClose: true,
          type: 'success',
          message: '操作成功!'
        })
      })
    },
    // 选中菜单
    clickCurrent (item) {
      this.pageNum = 1
      // 获取菜单详情列表
      this.getMenuDetailList(item.id)
      // 排他
      this.meunList.map(val => {
        val.checked = false
      })
      // 当前item高亮
      item.checked = true
      this.currentItem = item
      this.$set(this.meunList, this.meunList.length - 1, this.meunList[this.meunList.length - 1])
    },
    // 删除菜单
    del (id) {
      // 先判断该分类下是否存在视频 todo
      // “该分类下存在视频，删除失败”
      this.$confirm('确定要删除该名称吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.tableData.length > 0) {
          this.$message({
            showClose: true,
            type: 'error',
            message: '该分类下存在视频，删除失败!'
          })
          return
        }
        this.$http.deleteMenu({'id': id}).then(res => {
          this.$message({
            showClose: true,
            type: 'success',
            message: '操作成功!'
          })
          this.getMenuList().then(() => {
            this.clickCurrent(this.meunList[0])
          })
        })
      })
    },
    // 页容量
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.pageNum = 1
      this.getMenuDetailList(this.currentItem.id)
    },
    // 跳页
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.pageNum = val
      this.getMenuDetailList(this.currentItem.id)
    },
    // 编辑菜单
    editOpen (id, menuName) {
      this.input = menuName
      this.currentId = id
      this.dialogSort = true
    },
    // 菜单新增
    menuCreate () {
      if (this.input === '') {
        this.$message({
          showClose: true,
          type: 'error',
          message: '名称不能为空!'
        })
        return
      }
      let obj = {
        'menu_type': 3,
        'menu_name': this.input
      }
      if (this.currentId === '') {
        // 新增
        this.$http.helpCenterAddMenu(obj).then(res => {
          this.dialogSort = false
          this.$message({
            showClose: true,
            type: 'success',
            message: '保存成功!'
          })
          this.getMenuList().then(() => {
            this.clickCurrent(this.meunList[this.meunList.length - 1])
          })
        })
      } else {
        // 编辑
        obj.id = this.currentId
        this.$http.updateMenu(obj).then(res => {
          this.$message({
            showClose: true,
            type: 'success',
            message: '保存成功!'
          })
          this.getMenuList().then(() => {
            let obj1 = {}
            this.meunList.map(item => {
              if (item.id === this.currentId) {
                obj1 = item
              }
            })
            this.clickCurrent(obj1)
            this.dialogSort = false
          })
        })
      }
    },
    // 菜单新增弹窗关闭
    handleClose () {
      this.input = ''
      this.currentId = ''
    },
    // 获取菜单列表
    getMenuList () {
      return new Promise((resolve) => {
        let obj = {'menu_type': 3}
        this.$http.queryMenuList(obj).then(res => {
          this.meunList = res.dataList
          resolve()
        })
      })
    }
  },
  watch: {
    caseExplainDialog () {
      if (!this.caseExplainDialog) {
        this.getMenuDetailList(this.currentItem.id)
      }
    }
  },
  computed: {
    groundsList () {
      return {
        animation: 200,
        group: {name: 'aside', pull: true, put: true},
        sort: true,
        ghostClass: 'ghost',
        filter: '.no-drag'
      }
    },
    ...mapState({
      caseExplainDialog: state => {
        return state.caseExplain.caseExplainDialog
      }
    })
  }
}
</script>
<style lang="scss">
.case-explain {
  height: 100%;
  overflow: auto;
  >header {
    padding-right: 20px;
  }
  .title-box {
    float: left;
    width: 200px;
    height: 100%;
    border-right: 1px solid #E8E8E8;
    >i {
      float: right;
      color: #999999;
      cursor: pointer;
      font-size: 22px;
      margin-right: 22px;
      &:hover {
        color: #1890FF;
      }
    }
  }
  .content-bottom {
    height: calc(100% - 60px);
    .menu-bar {
      width: 220px;
      height: 100%;
      border-right: 1px solid #E8E8E8;
      .aside-body{
        padding-top:10px;
        height: 100%;
        overflow-y: auto;
        .list-item {
          height: 40px;
          padding-top: 10px;
          >i {
            font-size: 16px;
            color: #979797;
            cursor: pointer;
          }
          >span {
            margin-left: 10px;
            color: #333333;
            width: 125px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .icon-yidong {
            font-size: 19px;
            margin-left: 3px;
            cursor: move;
          }
          .icon-Rectangle1 {
            margin-right: 12px;
            margin-top: 2px;
            display: none;
          }
          .icon-Rectangle2 {
            margin-right: 12px;
            margin-top: 2px;
            display: none;
          }
          &:hover {
            background-color: #F0F2F5;
            .icon-Rectangle2,.icon-Rectangle1 {
              display: inline-block;
            }
          }
        }
        .list-item.active {
          background: #F0F2F5;
        }
      }
    }
    .detail-bar {
      width: calc(100% - 220px);
      height: 100%;
      .content-box {
        height: 100%;
        padding: 0;
      }
    }
  }
  .el-table{
    .icon-jianjuxiao,.icon-jianjuda {
      cursor: pointer;
      &:hover {
        color: #1890FF;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/help/case-explain.vue